import { render, staticRenderFns } from "./SectionsForm.vue?vue&type=template&id=38e58de5&"
import script from "./SectionsForm.vue?vue&type=script&lang=js&"
export * from "./SectionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports